var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("apply.no"),
                                        prop: "applyNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "handle-input",
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.applyNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "applyNo",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.applyNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("apply.applyType"),
                                        prop: "applyType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "handle-input",
                                          staticStyle: { width: "100%" },
                                          attrs: { clearable: "" },
                                          model: {
                                            value: _vm.queryCondition.applyType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "applyType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.applyType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("common.all"),
                                              value: "",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.applyTypeList,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label:
                                                    _vm._f("inputChoiceI18n")(
                                                      item
                                                    ),
                                                  value: item.code,
                                                },
                                              })
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("apply.subject"),
                                        prop: "subject",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "handle-input",
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.subject,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "subject",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.subject",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("apply.quotationType"),
                                        prop: "quotationType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "handle-input",
                                          staticStyle: { width: "100%" },
                                          attrs: { clearable: "" },
                                          model: {
                                            value:
                                              _vm.queryCondition.quotationType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "quotationType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.quotationType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("common.all"),
                                              value: "",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.quotationTypeList,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label:
                                                    _vm._f("inputChoiceI18n")(
                                                      item
                                                    ),
                                                  value: item.code,
                                                },
                                              })
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-transition",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "apply.shortlistedSuppliers"
                                                ),
                                                prop: "supplierCode",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  "suffix-icon":
                                                    "el-icon-search",
                                                },
                                                on: {
                                                  clear: _vm.clearSupplierName,
                                                },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    _vm.showSelSupplierDialog = true
                                                    _vm.SupplierNameDialogReset = true
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .supplierCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "supplierCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.supplierCode",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("apply.roundStatus"),
                                                prop: "roundStatus",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "handle-input",
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { clearable: "" },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .roundStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "roundStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.roundStatus",
                                                  },
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label:
                                                        _vm.$t("common.all"),
                                                      value: "",
                                                    },
                                                  }),
                                                  _vm._l(
                                                    _vm.roundStatusList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label:
                                                            _vm._f(
                                                              "inputChoiceI18n"
                                                            )(item),
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                clearable: "",
                                                label: "创建日期(从)",
                                                prop: "createDate",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "value-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  placeholder:
                                                    _vm.$t("common.selDate"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .createDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "createDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.createDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                clearable: "",
                                                label: "创建日期(至)",
                                                prop: "createEndDate",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "value-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  placeholder:
                                                    _vm.$t("common.selDate"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .createEndDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "createEndDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.createEndDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("common.createBy"),
                                                prop: "buyerName",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .buyerName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "buyerName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.buyerName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        type: "flex",
                        justify: "center",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.restQueryFormThis },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrowDown",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-arrow-up iconBtn"
                              : "el-icon-arrow-down iconBtn",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QuotationRoundInit,
                      expression: "QuotationRoundInit",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.showNewRoundDialogFunc },
                },
                [_vm._v(_vm._s(_vm.$t("apply.newRound")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QuotationCloseQuotation,
                      expression: "QuotationCloseQuotation",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.endQuotationFunc },
                },
                [_vm._v(_vm._s(_vm.$t("apply.endQuotaion")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QuotationRecoveryQuotation,
                      expression: "QuotationRecoveryQuotation",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.recoveryQuotationFunc },
                },
                [_vm._v(_vm._s(_vm.$t("apply.resumeQuotation")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.SourcingQuerySubmitData,
                      expression: "SourcingQuerySubmitData",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.createSourcing },
                },
                [_vm._v(_vm._s(_vm.$t("apply.confirmPrice")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.LineQuotationHistoryExport,
                      expression: "LineQuotationHistoryExport",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onExport },
                },
                [_vm._v(_vm._s(_vm.$t("common.export")))]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "quotationDataTable",
              staticClass: "table",
              attrs: {
                sortable: "",
                "max-height": "435",
                "row-key": "ttQuotationApplyRoundId",
                data: _vm.quotationList,
                border: "",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  fixed: "",
                  prop: "ttQuotationApplyRoundId",
                  "reserve-selection": true,
                  selectable: _vm.selectInit,
                  type: "selection",
                  width: "55",
                  label: _vm.$t("common.select"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  fixed: "",
                  sortable: "",
                  prop: "applyNo",
                  label: _vm.$t("apply.no"),
                  "min-width": "100px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.openQuotationApplyDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.applyNo) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "applyTypeI18n",
                  label: _vm.$t("apply.applyType"),
                  "min-width": "90px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "subject",
                  label: _vm.$t("apply.subject"),
                  "min-width": "180px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "supplierNames",
                  label: _vm.$t("apply.shortlistedSuppliers"),
                  "min-width": "180px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "quotationTypeI18n",
                  label: _vm.$t("apply.quotationType"),
                  "min-width": "90px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "roundNumber",
                  label: _vm.$t("common.operation"),
                  "min-width": "80px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.roundStatus !== "4"
                          ? _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openQuotationDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.quote")))]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "roundNumber",
                  label: _vm.$t("apply.round"),
                  "min-width": "80px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.openQuotationHistory(
                                  scope.row.ttQuotationApplyId
                                )
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.roundNumber) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "roundStatusI18n",
                  label: _vm.$t("apply.roundStatus"),
                  "min-width": "100px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "name",
                  label: _vm.$t("common.createBy"),
                  "min-width": "100px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "createDate",
                  label: _vm.$t("common.createDate"),
                  "min-width": "100px",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _vm.SupplierNameDialogReset
            ? _c("SelSupplier", {
                ref: "supplierSelRef",
                attrs: { multipleSelectionFlag: false },
                on: { subCallMethod: _vm.selectSupplierMethod },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("apply.newRound"),
            visible: _vm.showNewRoundDialog,
            width: "65%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showNewRoundDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "pickupPointForm",
              staticClass: "form_border",
              attrs: {
                "label-position": _vm.labelPosition,
                "label-width": "120px",
              },
            },
            [
              _c(
                "div",
                { staticClass: "handle-box" },
                [
                  _c(
                    "el-row",
                    [
                      _vm.showSaveNewRoundFlag
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.QuotationCreateNewRound,
                                  expression: "QuotationCreateNewRound",
                                },
                              ],
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.saveNewRoundFunc },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.submit")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      ref: "newRoundHeadDataForm",
                      attrs: {
                        model: _vm.newRoundHeadData,
                        "label-position": _vm.labelPosition,
                        "label-width": "140px",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 5 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("apply.no") } },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: true },
                                    model: {
                                      value: _vm.newRoundHeadData.applyNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newRoundHeadData,
                                          "applyNo",
                                          $$v
                                        )
                                      },
                                      expression: "newRoundHeadData.applyNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("apply.applyType"),
                                    prop: "applyType",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.newRoundHeadData.applyType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newRoundHeadData,
                                            "applyType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "newRoundHeadData.applyType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.applyTypeList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label:
                                              _vm._f("inputChoiceI18n")(item),
                                            value: item.code,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("apply.subject") } },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: true },
                                    model: {
                                      value: _vm.newRoundHeadData.subject,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newRoundHeadData,
                                          "subject",
                                          $$v
                                        )
                                      },
                                      expression: "newRoundHeadData.subject",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 5 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("apply.quotationType"),
                                    prop: "quotationType",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { disabled: true },
                                      model: {
                                        value:
                                          _vm.newRoundHeadData.quotationType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newRoundHeadData,
                                            "quotationType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "newRoundHeadData.quotationType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.quotationTypeList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label:
                                              _vm._f("inputChoiceI18n")(item),
                                            value: item.code,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("apply.round") } },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: true },
                                    model: {
                                      value: _vm.newRoundNumber,
                                      callback: function ($$v) {
                                        _vm.newRoundNumber = $$v
                                      },
                                      expression: "newRoundNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 5 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 18 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("apply.roundRemark") },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: _vm.roundRemark,
                                      callback: function ($$v) {
                                        _vm.roundRemark = $$v
                                      },
                                      expression: "roundRemark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 5 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 18 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("common.attachment"),
                                    size: "small",
                                  },
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "upload",
                                      staticClass: "upload-demo",
                                      attrs: {
                                        headers: _vm.header,
                                        action: _vm.fileUploadUrl,
                                        "on-success": _vm.uploadSuccess,
                                        "on-remove": _vm.handleRemove,
                                        multiple: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.selectFile"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 5 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 18 } },
                            [
                              _c(
                                "el-table",
                                {
                                  ref: "supplierListDataTable",
                                  attrs: {
                                    data: _vm.supplierList,
                                    border: "",
                                    "highlight-current-row": "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "supplierCode",
                                      label: _vm.$t("apply.supplierCode"),
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "supplierName",
                                      label: _vm.$t("apply.supplierName"),
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      width: "55px",
                                      prop: "tmSupplierId",
                                      selectable: _vm.selectableMethod,
                                      type: "selection",
                                      label: _vm.$t("apply.whetherToIssue"),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("quoteByLine.sourcing.submitTitle"),
            visible: _vm.showSourcingDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSourcingDialog = $event
            },
          },
        },
        [
          _c("SelSourcing", {
            ref: "sourcingRef",
            attrs: { sourcingList: _vm.sourcingList },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "以下申请单报价明细的预估年总费用没有维护请维护后再进行结束询价",
            visible: _vm.showNewErrorDialog,
            width: "660px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showNewErrorDialog = $event
            },
          },
        },
        [
          _c("el-card", { staticClass: "box-card" }, [
            _c(
              "div",
              { staticClass: "handle-box" },
              [
                _c(
                  "el-table",
                  {
                    staticClass: "table",
                    staticStyle: { width: "100%" },
                    attrs: {
                      sortable: "",
                      "close-on-click-modal": false,
                      data: _vm.errorList,
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        ali: "",
                        sortable: "",
                        prop: "applyNo",
                        label: "申请单编号",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }